import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import ServiceConvoyage from "@/pages/ServiceConvoyage";
import ServiceVTC from "@/pages/ServiceVTC";
import ServiceNettoyage from "@/pages/ServiceNettoyage";
import ServiceDepannage from "@/pages/ServiceDepannage";
import ConvoyageBooking from "@/pages/ConvoyageBooking";
import VTCBooking from "@/pages/VTCBooking";
import NettoyageBooking from "@/pages/NettoyageBooking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import TrackBooking from "@/pages/TrackBooking";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import CGV from "@/pages/CGV";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBookingDetail from "@/pages/AdminBookingDetail";
import AdminSettings from "@/pages/AdminSettings";
import AdminQrCodes from "@/pages/AdminQrCodes";
import AdminWaitlist from "@/pages/AdminWaitlist";
import AdminPlanning from "@/pages/AdminPlanning";
import NotFound from "@/pages/NotFound";
import WhatsAppButton from "@/components/WhatsAppButton";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import { SettingsProvider } from "@/context/SettingsContext";
import "@/App.css";

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services/convoyage" element={<ServiceConvoyage />} />
          <Route path="/services/vtc" element={<ServiceVTC />} />
          <Route path="/services/nettoyage" element={<ServiceNettoyage />} />
          <Route path="/services/depannage" element={<ServiceDepannage />} />
          <Route path="/convoyage" element={<ConvoyageBooking />} />
          <Route path="/vtc" element={<VTCBooking />} />
          <Route path="/nettoyage" element={<NettoyageBooking />} />
          <Route path="/paiement/succes" element={<PaymentSuccess />} />
          <Route path="/paiement/annule" element={<PaymentCancel />} />
          <Route path="/suivi" element={<TrackBooking />} />
          <Route path="/suivi/:reference" element={<TrackBooking />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/bookings/:id" element={<AdminBookingDetail />} />
          <Route path="/admin/planning" element={<AdminPlanning />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/qr-codes" element={<AdminQrCodes />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <WhatsAppButton />
        <CookieBanner />
      </BrowserRouter>
      <Toaster theme="dark" richColors position="top-right" />
    </SettingsProvider>
  );
}

export default App;
